import React from 'react';
import { useDispatch } from 'react-redux';
import FormControl from '@material-ui/core/FormControl';
import { FormGroup } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { ComponentInputType, ConfiguratorComponent } from './types';
import { FieldType } from '../FormBuilder/types';
import { useStyles } from '../FormBuilder/styles';
import { selectSystemParameterOptionSync } from '../../Reducers/Configurator/Actions';

interface FormControlRendererProps {
  componentInputTypes: ComponentInputType;
  component: ConfiguratorComponent;
}

const ComponentFieldRenderer: React.FC<FormControlRendererProps> = (props) => {
  const { componentInputTypes, component } = props;
  const dispatch = useDispatch();
  const classes = useStyles();

  const handleChange = (component, option) => dispatch(selectSystemParameterOptionSync(component, option));

  const getInputType = (component) =>
    componentInputTypes[component.identifier] ? componentInputTypes[component.identifier] : FieldType.SELECT;

  switch (getInputType(component)) {
    case FieldType.CHECKBOX: {
      return (
        <FormControl component="fieldset" className={classes.formControl}>
          <FormGroup>
            {component.options.map((option) => {
              const selectedOption = component.selectedOptions.find(
                ({ identifier }) => identifier === option.identifier
              );
              return (
                <FormControlLabel
                  key={option.identifier}
                  className={classes.formControlLabel}
                  control={
                    <Checkbox
                      className={classes.checkbox}
                      checked={!!selectedOption}
                      onChange={() => {
                        handleChange(component, selectedOption || option);
                      }}
                    />
                  }
                  label={option.title}
                />
              );
            })}
          </FormGroup>
        </FormControl>
      );
    }
    case FieldType.SELECT: {
      return (
        <FormControl key={component.identifier} variant="outlined" className={classes.formControl}>
          <Select
            displayEmpty
            value={component.selectedOptions[0]?.identifier || ''}
            className={classes.select}
            onChange={(evt) => {
              handleChange(
                component,
                component.options.find(({ identifier }) => identifier === evt.target.value)
              );
            }}
            renderValue={(selected: string) => {
              if (selected.length === 0) {
                return 'Please choose';
              }
              return component.options.find(({ identifier }) => identifier === selected)?.title;
            }}
          >
            {component.options.map((option) => (
              <MenuItem key={option.identifier} value={option.identifier}>
                {option.title}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      );
    }

    default:
      return null;
  }
};

export default ComponentFieldRenderer;
